/*
 *
  Chạy Local
 *
 */

/*let baseUrl = "http://localhost:8787/";
let serveUrl = "http://localhost/";
module.exports = {
  search: baseUrl + 'public/api/tblmusic/GetListMusicSaerch',
  songDetail: baseUrl + 'public/api/TblMusic/GetListMusicDetail',
  bxhhome: baseUrl + 'public/api/TblRank/GetCurrentListRank',
  adv: baseUrl + 'public/api/Adv/GetListAdv',
  slide: baseUrl + 'public/api/Banner/BannerSlide',
  youMayLike: baseUrl + 'public/api/TblMusic/GetListMayBeYouLike',
  mostSinger: baseUrl + 'public/api/Tblsinger/GetListSingerHot',
  latest: baseUrl + 'public/api/TblMusic/GetListNewMusic',
  albumHot: baseUrl + 'public/api/TblAlbum/GetListAllBumHot',
  albumDetail: baseUrl + 'public/api/tblmusic/GetListMusicByAlbum',
  otherAlbum: baseUrl + 'public/api/tblalbum/GetListAlbum',
  news: baseUrl + 'public/api/news/GetListNewsByCategoryCodePage',
  newsDetail: baseUrl + 'public/api/news/GetListNewById',
  bxh: baseUrl + 'public/api/tblrank/GetListMusicByRank',
  songCategoryList: baseUrl + 'public/api/ListCountry/GetListCountryCategory',
  songListByCategory: baseUrl + 'public/api/TblMusic/GetListMusicBySubCategory',
  singerTop: baseUrl + 'public/api/Tblsinger/GetListSingerHot',
  singerListByAlpha: baseUrl + 'public/api/Tblsinger/GetListSingerAlphabet',
  singerDetail: baseUrl + 'public/api/tblsinger/GetListSingerDetail',
  songListBySinger: baseUrl + 'public/api/tblmusic/GetListMusicBySinger',
  slieNews: baseUrl + 'public/api/news/GetListNewsByLatest',
  subCategoryByCategory: baseUrl + 'public/api/tblcategory/GetListSubCategoryByCotegoryCode',
  newsListBySubCategory: baseUrl + 'public/api/news/GetListNewsBySubCategoryCode',
  guideList: baseUrl + 'public/api/news/GetListNewsByCategoryCode',
  login: baseUrl + 'public/api/tblotp/GetInfoOtp',
  paramLogin: baseUrl + 'public/api/tblotp/GetInfoParamater',
  songListRandomBySinger: baseUrl + 'public/api/tblmusic/GetListRandomMusicBySinger',
  checkRegister: baseUrl + 'pm/api/GuiCustomer/GuiGetMsisndInfo',
  saveLog: baseUrl + 'public/api/TblLogAccess/InsertLogaAccess',
  checkTelco: serveUrl + 'checktelco.php',
  getPhone: serveUrl + 'getphone.php',
  register: serveUrl + 'register.php',
  getInfoAccessDevice: serveUrl + 'getInfoAccess.php',
  getHeader: serveUrl + 'getheader.php'
}*/



/*
 *
  Chạy trên Nginx Product
 *
 */

let baseUrl = "http://103.68.240.137:8787/";
let serveUrl = "http://quatangamnhac.vn/";
module.exports = {
  search: '/getdata/tblmusic/GetListMusicSaerch',
  songDetail: '/getdata/TblMusic/GetListMusicDetail',
  bxhhome: '/getdata/TblRank/GetCurrentListRank',
  adv: '/getdata/Adv/GetListAdv',
  slide: '/getdata/Banner/BannerSlide',
  youMayLike: '/getdata/TblMusic/GetListMayBeYouLike',
  mostSinger: '/getdata/Tblsinger/GetListSingerHot',
  latest: '/getdata/TblMusic/GetListNewMusic',
  albumHot: '/getdata/TblAlbum/GetListAllBumHot',
  albumDetail: '/getdata/tblmusic/GetListMusicByAlbum',
  otherAlbum: '/getdata/tblalbum/GetListAlbum',
  news: '/getdata/news/GetListNewsByCategoryCodePage',
  newsDetail: '/getdata/news/GetListNewById',
  bxh: '/getdata/tblrank/GetListMusicByRank',
  songCategoryList: '/getdata/ListCountry/GetListCountryCategory',
  songListByCategory: '/getdata/TblMusic/GetListMusicBySubCategory',
  singerTop: '/getdata/Tblsinger/GetListSingerHot',
  singerListByAlpha: '/getdata/Tblsinger/GetListSingerAlphabet',
  singerDetail: '/getdata/Tblsinger/GetListSingerDetail',
  songListBySinger: '/getdata/tblmusic/GetListMusicBySinger',
  slieNews: '/getdata/news/GetListNewsByLatest',
  subCategoryByCategory: '/getdata/tblcategory/GetListSubCategoryByCotegoryCode',
  newsListBySubCategory: '/getdata/news/GetListNewsBySubCategoryCode',
  guideList: '/getdata/news/GetListNewsByCategoryCode',
  login: '/getdata/tblotp/GetInfoOtp',
  paramLogin: '/getdata/tblotp/GetInfoParamater',
  songListRandomBySinger: '/getdata/tblmusic/GetListRandomMusicBySinger',
  checkRegister: '/checkregister/GuiCustomer/GuiGetMsisndInfo',
  saveLog: '/getdata/TblLogAccess/InsertLogaAccess',
  checkTelco: '/checktelco.php',
  getPhone: '/getphone.php',
  register: '/register.php',
  getInfoAccessDevice: '/getInfoAccess.php',
  getHeader: '/getheader.php'
}



// WEBPACK FOOTER //
// ./src/api.js